export enum ReceiptType {
    Html = "Html",
    Pdf = "Pdf",
    Image = "Image"
}

export enum ReceiptPurpose {
    Printer,
    Email
}

export enum ReceiptStep {
    Print = 0,
    Email = 1,
    PrintAndEmail = 2,
    None = 3
}
